import React from 'react';


export const appear = (id, delay = 100) => {
    window.setTimeout(() => {
        const content = document.getElementById(id);
        if (isNotNull(content) && !content.classList.contains('visible'))
            content.classList.add('visible');
    }, delay);
};